module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/sanjiao-right.7234a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/sanjiao-right.png
// module id = TZUP
// module chunks = 1